import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';
import { type FabricError } from '../fabric-error/index.js';
import {
  type FabricToolbarNavbarOptions,
  type ToolbarCallbackAction,
  type ToolbarNavbarItemType,
} from './set-navbar.js';

export type FabricToolbarUpdateNavbarApi = <
  T1 extends ToolbarNavbarItemType,
  T2 extends ToolbarNavbarItemType,
  T3 extends ToolbarNavbarItemType,
>(
  options: FabricToolbarNavbarOptions<T1, T2, T3>,
  callback?:
    | ((
        err: FabricError | null,
        clickedItemTag: string,
        action: ToolbarCallbackAction
      ) => void)
    | undefined
) => void;

export const updateNavbar: FabricToolbarUpdateNavbarApi = <
  T1 extends ToolbarNavbarItemType,
  T2 extends ToolbarNavbarItemType,
  T3 extends ToolbarNavbarItemType,
>(
  options: FabricToolbarNavbarOptions<T1, T2, T3>,
  callback?: (
    err: FabricError | null,
    clickedItemTag: string,
    action: ToolbarCallbackAction
  ) => void
) => {
  core.call<
    'fabric_toolbar.updateNavbar',
    FabricToolbarNavbarOptions<T1, T2, T3>,
    string
  >(
    'fabric_toolbar.updateNavbar',
    options,
    callback
      ? (result) => {
          const fabricErrors = filterFabricErrors(
            result.code,
            result.message,
            result.data
          );
          // 如果code==='1', 约定当前为清理上一次的callback函数使用, 不做业务回调处理.
          // 当多次调用setNavbar, updateNavbar时候避免内存泄漏问题.
          if (fabricErrors?.code === '1') {
            return;
          }
          callback(fabricErrors || null, result.data, 'update');
        }
      : undefined
  );
};
